import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);

    // CUSTOM EDIT START: Some Shopify-authored RTE images retain their selected display size in a width attribute,
    // which Horizon's global img width overrides. Promote a retained size to inline CSS while preserving max-width.
    this.querySelectorAll('img[width]').forEach(this.#formatImage);
    // CUSTOM EDIT END
  }

  // CUSTOM EDIT START: Preserve article and page image sizing when Shopify retains a numeric width attribute.
  /**
   * Restores the saved display width with enough cascade priority to override the global image rule.
   * @param {HTMLImageElement} image
   */
  #formatImage(image) {
    const savedWidth = image.getAttribute('width')?.trim();

    if (image.style.width || !savedWidth || !/^\d+$/.test(savedWidth) || Number(savedWidth) <= 0) return;

    image.style.width = `${savedWidth}px`;
  }
  // CUSTOM EDIT END

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
